function Notifications() {
  return (
    <svg width="20" height="20" viewBox="0 0 28 28">
      <path d="M7.847 23.488c1.36 0 3.596-.125 6.62-.682a3.72 3.72 0 01-3.487 2.441 3.718 3.718 0 01-3.155-1.759h.022zm17.076-7.758c.247 1.272-.645 2.397-2.653 3.346-1.1.519-3.546 1.507-7.586 2.293-3.116.605-5.399.744-6.836.744-.427 0-.78-.012-1.058-.028-2.216-.127-3.466-.837-3.713-2.109-.375-1.927.218-2.671 1.201-3.903l.259-.325c.663-.841.922-1.667.498-3.846-.949-4.88 1.249-8.215 6.029-9.149 4.782-.923 8.07 1.343 9.019 6.224.423 2.179.973 2.847 1.903 3.378v.001l.362.205c1.372.774 2.2 1.241 2.575 3.169z"></path>
    </svg>
  );
}

export default Notifications;
